<template>
  <div>
    <BreadCrumb :data="breadCrumb" />
    <b-card class="formGroup">
      <Form ref="BarcodeForm"  :forms="BarcodeForm" />
      <template v-if="barcodes.length > 0">
        <b-spinner v-if="localeLoading" variant="primary" label="Spinning"></b-spinner>
          <div v-else id="barcodes" style=" display: flex; justify-content: space-between; flex-wrap: wrap;">
            <div class="barcodeBox" v-for=" ( b,i ) in barcodes" :key="i">
              <svg 
                class="barcode" 
                jsbarcode-format="auto"
                :jsbarcode-value="b"
                :jsbarcode-height="pageOpt.barcodeHeight"
                :jsbarcode-width="pageOpt.barcodeWidth"
                :jsbarcode-fontsize="pageOpt.barcodeFontSize"
                jsbarcode-fontoptions="bold"></svg>
            </div>
              
          </div>
      <div style="display: flex; justify-content: space-between; align-items: center;flex-wrap: wrap; flex: 1; ">
          
          <div style="display: flex; "> 
            <label> Barkod Yüksekliği </label>
            <b-form-input style="width: 100px" v-model="pageOpt['barcodeHeight']" @change="reRenderBarcode" />
          </div>

          <div style="display: flex; "> 
            <label> Barkod Çizgi Genişliği </label>
            <b-form-input style="width: 100px" v-model="pageOpt['barcodeWidth']" @change="reRenderBarcode"  />
          </div>

          <div style="display: flex; "> 
            <label> Barkod Yazı Boyutu </label>
            <b-form-input style="width: 100px" v-model="pageOpt['barcodeFontSize']" @change="reRenderBarcode"  />
          </div>
        </div>
       
      </template>
      <template v-slot:footer class="footer">
          <b-button :disabled='isLoading' variant="primary" @click="saveForm">Barkod Üret</b-button>
          <b-button :disabled='isLoading' v-if="barcodes.length > 0" variant="danger" @click="clearBarcode">Barkodları Temizle</b-button>
          <b-button :disabled='isLoading' v-if="barcodes.length > 0" variant="warning" 
            @click="openModal(true, 'stock', {product_serial_numbers: barcodes, quantity: $refs.BarcodeForm.formData.count, product_id: $refs.BarcodeForm.formData.stock})">
            Stok Girişi Yap
          </b-button>
          <b-button :disabled='isLoading' v-if="barcodes.length > 0" variant="success" v-print="'#barcodes'"> Yazdır </b-button>

       </template>
    </b-card>
    <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
  </div>
</template>

<script>
let breadCrumb = [
  { label: 'Stoklar', url: "/Stock/List" },
  { label: 'Barkod Oluştur', url: "" },
];
import VueHtml2pdf from 'vue-html2pdf'
import BreadCrumb from "@/components/BreadCrumb";
import Form from '@/components/Form'
import Modals from './modals'
import Forms from './forms'
import JsBarcode from 'jsbarcode'
import print from 'vue-print-nb'

export default {
  directives:{
    print
  },
  data() {
    return {
      breadCrumb,
      BarcodeForm: Forms.Barcode,
      localeLoading: false,
      barcodes: [],
      pageOpt: {
        barcodeHeight: '400',
        barcodeWidth: '10',
        barcodeFontSize: 200

      },
      currentForm: "Barcode",
      modalOpen: false,
      modalProps: {},
      modalName: "",
    }
  },
  components: {
    BreadCrumb, Form, VueHtml2pdf, Modals
  },
  computed: {
    isLoading() {
      return this.$store.getters.getStockLoading
    },
    stockStatus() {
      return this.$store.getters.getStockStatus
    }
  },
  methods: {
    saveForm() {
      this.$refs.BarcodeForm.$refs.Form.validate().then(async success => {
        if (success) {
          this.createBarcodes(this.$refs.BarcodeForm.formData)
        }
      })
    },
    reRenderBarcode(){
      JsBarcode(".barcode").init();
    },

    clearBarcode(){
      this.barcodes = []
    },

    getReport(){
      this.$refs.html2Pdf.generatePdf()
    },
    openModal: function(state, modal, props){
      this.modalOpen = state
      if(state){
        this.modalProps = props
        this.modalName = modal
      }
    },
   async createBarcodes(data){
      let bc = ''
      bc = bc + (data.year ? data.year : '') + (data.month ? data.month : '')+ (data.code ? data.code : '')
      this.fBarcode = bc
      this.localeLoading = true
      for(let i=parseInt(data.startNu); i<(parseInt(data.startNu) + parseInt(data.count)); i++){
        this.barcodes.push(bc + Array(parseInt(data.length+1)-i.toString().length).join('0')+i.toString())
      }
      await setTimeout(() => {
        JsBarcode('.barcode').init()
      }, 1000 )
      this.localeLoading = false

    }
  }
}
</script>

<style>
    @import "./styles/add.min.css"; 
    .html2pdf__page-break {
      margin: 30px !important;
    }
    .card-body{
      display: flex;
      flex-wrap: wrap;
      flex: 1;
    }
    .barcode{
      width: 100px;
      height: 50px;
    }
    .barcodeBox{
      display: flex;
      flex-direction: column;
      justify-content: center; 
      align-items: center;
      margin:0 .3rem;
    }
    span{
      font-weight: bold;
    }

    @media print{
      .barcodeBox {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100vh;
      }
      .barcode{
        width: 100vh;
        height: 100vw;
        transform:rotate(90deg) !important;

      }
      span{
        font: bold 96px monospace;
        position: absolute;
        top:10%;
        width: 100%
      }
    }


</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/Barcode.vue